import qs from 'qs'

const fields = [
  'title',
  'slug'
]

export const queryParticipantEntryBySlug = (options: QueryBySlugOrIdOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields,
      populate: {
        ...queryFragmentBlocks
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `participant-entries?${query}`
}
